import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ParentChildService } from '../parentchild-advanceQ.service';
import { NoticeboardService } from '../../../../../components/noticeboard/noticeboard/noticeboard.service';
import { ConfirmationService, Paginator } from 'primeng/primeng';
import { DropdownModule } from 'primeng/primeng';
import { LocalStorageService } from "ng2-webstorage";
import { MessageService } from 'primeng/components/common/messageservice';
import { addParentChildModel } from '../../../../../components/parentchild/addparent/addparentchild.model';
import { element } from 'protractor';

@Component({
  selector: 'StudentveiwHQ',
  templateUrl: 'StudentveiwHQ.component.html',
  styleUrls: ['StudentveiwHQ.component.scss']
})

export class StudentveiwHQComponent implements OnInit {
  @ViewChild('paginator') paginator: Paginator
  // display: boolean = false;
  // editDisplay:boolean=false;
  display = "none";
  editDisplay = "none";
  public data: any;
  public childInfo: any;
  public ChildGenderId : number;
  public childview: any;
  public Mappeddata: any;
  public Sections: any;
  public maxSize: number = 10;
  public bigTotalItems: number;
  public bigCurrentPage: number = 1;
  public numPages: number = 0;
  public addeventmodel: any;
  public StandardId: any;
  public SectionId: any;
  public searchString:any;
  public input:any;
  public spinnershow: boolean = false;
  public selectedRows: number = 10;
  public addparentchildmodel=new addParentChildModel();
  public isUserSchoolAdmin: boolean = false;

  public HigherEdchildinfo: any;
  public HigherEdchildcourse: any;
  public selectedCourse: string = '';
  public HigherEdchildBatch: any;
  public selectedbatch: string = '';
  public selectedChildInfo: string = '';

  tempSection: any;

  constructor(private noticeboardService: NoticeboardService, private localStorage: LocalStorageService, private messageService: MessageService, private confirmationService: ConfirmationService, private parentchildservice: ParentChildService, private router: Router) {
    this.Sections =null;
    // this.Sections=true;

  }
  ngOnInit() {
    this.isUserSchoolAdmin = this.localStorage.retrieve("IsSchoolAdminUser");
       
    this.GetCourseList();
  }

  //------------------------------------------------------------------------------------

  private GetCourseList(){
    this.parentchildservice.getHigherEdChildCourseList().finally(() => { }).subscribe(
      response => {
        this.HigherEdchildcourse = response['items'];
        try {
          this.selectedCourse =  this.HigherEdchildcourse[0].CourseId;
          this.getHigherEdChildBatch()
        } catch (error) {
          
        }
        console.log('HigherEdchildcourse',this.HigherEdchildcourse)
      },
      error => {
        console.error(error);
      });
  };

  changecourse() {
   console.log("courseT",this.selectedCourse)
   this.getHigherEdChildBatch();
  };

//-----------------------------------------------------------------------------------------------

  private getHigherEdChildBatch(){
    this.parentchildservice.getHigherEdChildBatchList(this.selectedCourse).finally(() => { }).subscribe(
      response => {
        this.HigherEdchildBatch = response['Value'];
        try {
          this.selectedbatch =  this.HigherEdchildBatch[0].Id;
          this.GetHiEduChildInfo()
        } catch (error) {
          
        }
        console.log('HigherEdchildBatch',this.HigherEdchildBatch)
      },
      error => {
        console.error(error);
      });
  };

  changebatch() {
    console.log("batchT",this.selectedbatch)
    this.GetHiEduChildInfo();
   };

//----------------------------------------------------------------------------------------------*/

private GetHiEduChildInfo(){
  this.parentchildservice.getHiEduChildInfo(this.selectedCourse, this.selectedbatch).finally(() => { }).subscribe(
    response => {
      this.HigherEdchildinfo = response;
      console.log('HigherEdchildinfo',this.HigherEdchildinfo)
    },
    error => {
      console.error(error);
    });
};

changeChildInfo() {
  console.log("ChildInfoT",this.selectedChildInfo)
 };

//---------------------------------------------------------------------------------------------------

  onSearchChange(searchString) {
    this.searchString = searchString;
    this.getChildsList(this.bigCurrentPage,this.selectedRows);
  }
  private updateCurrentPage(currentPage: number): void {
    setTimeout(() => this.paginator.changePage(currentPage));
  }


  private getChildsList(pagenum,rows) {
    this.spinnershow = true;
    this.parentchildservice.getChildNameList(pagenum, this.searchString).finally(() => { this.spinnershow = false }).subscribe(
      response => {
        this.bigTotalItems = (Number(response['TotalPages']) * this.maxSize);
        this.data = response['items'];
      },
      error => {
      });
  }

  searchDetails() {
    if(!this.StandardId)this.StandardId='';
    if(!this.SectionId) this.SectionId='';
    if(!this.searchString) this.searchString='';
    this.parentchildservice.GetParentsListBySearch(1,this.StandardId, this.SectionId,this.searchString).finally(() => { }).subscribe(
      response => {
         this.bigTotalItems = (Number(response['TotalPages']) * this.maxSize);
        this.data = response['items'];
        console.log(this.data);
        this.updateCurrentPage(0);
      },
      error => {
      });
  }

  sortingfunc(a, b) { //Added by Sashitha to sort grades by numbers first then alphabetically. Issue was 1,10,2,3,4,a,b like that. Fixed to 1,2,3,4,10,a,b
    if(!isNaN(a.standardsName) && !isNaN(parseFloat(a.standardsName)) && !isNaN(b.standardsName) && !isNaN(parseFloat(b.standardsName))){
      if (Number(a.standardsName) < Number(b.standardsName)){
        return -1;
      }
      if (Number(a.standardsName) > Number(b.standardsName)){
        return 1;
      }
    }else{
      if (a.standardsName < b.standardsName){
        return -1;
      }
      if (a.standardsName > b.standardsName){
        return 1;
      }
    }
    return 0;
  }

  public postParentChildUpdate(childInfo) {
    //this.addDepartmentmodel['schoolId'] = this.schoolId;
    this.parentchildservice.updateParentChildList(childInfo).finally(() => { }).subscribe(
      response => {
        // this.editDisplay= false;
        // this.display = false;
        this.editDisplay = "none";
        this.display = "none";
        this.getParentsList(this.bigCurrentPage, this.selectedRows);
        this.messageService.add({ severity: 'success', summary: 'Talkative Parents', detail: 'Updated Successfully' });
      },
      error => {console.log(error) });
  };


  private getParentsList(pagenum, rows) {
    this.parentchildservice.GetParentsList(pagenum, rows).finally(() => { }).subscribe(
      response => {
        this.bigTotalItems = (Number(response['TotalPages']) * this.maxSize);
        console.log('pagination',this.bigTotalItems)
        this.data = response['items'];
        console.log('response',this.data)
      },
      error => {

      });
  };

  confirm() {
    this.confirmationService.confirm({
      message: 'Are you sure that you want to perform this action?',
      accept: () => {
        //Actual logic to perform a confirmation
      }
    });
  }
  viewChild(parentChild){
    this.childview =parentChild;
    // this.display = true;
    this.display = "block";
    console.log("childnamehhhh",this.childview);
  }
  viewChildAdvanced(parentChild){
    this.router.navigate(['/parent/1221/student-profile/']);
  }

  onCloseHandled() {
    this.display = "none";
  }

  editChild(parentChild) {
    // this.editDisplay = true;
    this.editDisplay = "block";
    this.childInfo = parentChild;
    console.log(parentChild,'parentChild')

  }

  onCloseHandled1() {
    this.editDisplay = "none";
  }


  pageChanged(event) {
    console.log(event);
    this.bigCurrentPage = event.page+1;
    this.selectedRows = event.rows;
    console.log("page",this.bigCurrentPage);
    console.log("rows",this.selectedRows);
    // this.getParentsList(event.page);

    if(!this.StandardId)this.StandardId='';
    if(!this.SectionId) this.SectionId='';
    if(!this.searchString) this.searchString='';
    this.parentchildservice.GetParentsListBySearch(this.bigCurrentPage,this.StandardId, this.SectionId,this.searchString).finally(() => { }).subscribe(
      response => {
         this.bigTotalItems = (Number(response['TotalPages']) * this.maxSize);
        this.data = response['items'];
        console.log(this.data);
      },
      error => {
      });
  }
  gotoAddParent() {
    this.router.navigate(['parentchild/addparentchild'])
  }
}



// WEBPACK FOOTER //
// /builds/yaratechnologies/talkative-parents-portal/src/app/parent/dashboard/pages/parentchild/viewhigherend/StudentveiwHQ.component.ts